import styled from "styled-components";

export const Container = styled.section`
    width: 100%;
    margin: 100px 0;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const ContainerData = styled.div`
    max-width: 1000px;
    padding: 0 30px;
`;

export const Title = styled.h1`
    padding: 30px 0;
    text-align: center;
    font-size: 26px;
    font-weight: 700;
    text-align: center;
`;
